import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { DevicesComponent } from './devices/devices.component';
import { DeviceDashboardComponent } from './device-dashboard/device-dashboard.component';
import { ActiveDeviceReportComponent } from './active-device-report/active-device-report.component';
import { StoreLogoComponent } from './store-logo/store-logo.component';
import { DeviceSettingsComponent } from './device-settings/device-settings.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssetLibraryModule } from '../../modules/asset-library/asset-library.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { DeviceSegmentsComponent } from './device-segments/device-segments.component';
import { LivePreviewModule } from '../../../app/common/components/live-preview/live-preview.module';
import { PipeUtilModule } from '../pipes/pipe-util/pipe-util.module';
import { AttractLoopPopupModule } from '../../../app/common/components/attract-loop-popup/attract-loop-popup.module';
import { CreateProfileModule } from '../create-profile/create-profile.module';
import { PasswordPopupComponent } from './device-settings/device-setting-popup/password-popup/password-popup.component';
import { DeviceInfoComponent } from './device-info/device-info.component';
import { DevicePromoContentComponent } from './device-promo-content/device-promo-content.component';
import { DevicePriceContentComponent } from './device-price-content/device-price-content.component';
import { DeviceBannerCarouselComponent } from './device-banner-carousel/device-banner-carousel.component';
import { DeviceFactTagsComponent } from './device-fact-tags/device-fact-tags.component';
import { PushUpdateComponent } from './push-update/push-update.component';
import { SpinnerInterceptor } from '../../core/routing/interceptors/spinner.interceptor';
import { DeviceAutoShutdownComponent } from './device-auto-shutdown/device-auto-shutdown.component';
import { DateTimeZoneModule } from '../../common/components/date-time-zone/date-time-zone.component/date-time-zone.module'
import { DeviceCustomMainTileComponent } from './device-custom-main-tile/device-custom-main-tile.component';
import { PushPromosComponent } from './push-promos/push-promos.component';
import { SrtKioskDashboardComponent } from './srt-kiosk-dashboard/srt-kiosk-dashboard.component';
import { DeviceIdleExperienceComponent } from './device-idle-experience/device-idle-experience.component';
import { SortModule } from '../../modules/sort/sort.module';

@NgModule({
  declarations: [
    DevicesComponent,
    DeviceDashboardComponent,
    ActiveDeviceReportComponent,
    StoreLogoComponent,
    DeviceSettingsComponent,
    DeviceSegmentsComponent,
    PasswordPopupComponent,
    DeviceInfoComponent,
    DevicePromoContentComponent,
    DevicePriceContentComponent,
    DeviceBannerCarouselComponent,
    DeviceFactTagsComponent,
    PushUpdateComponent,
    DeviceAutoShutdownComponent,
    DeviceCustomMainTileComponent,
    PushPromosComponent,
    SrtKioskDashboardComponent,
    DeviceIdleExperienceComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    AssetLibraryModule,
    ColorPickerModule,
    LivePreviewModule,
    PipeUtilModule,
    AttractLoopPopupModule,
    CreateProfileModule,
    DragDropModule,
    DateTimeZoneModule,
    SortModule
  ],
  providers: [
   SpinnerInterceptor
  ],
  exports:[
    DeviceDashboardComponent
  ]
})

export class DevicesModule { }
